import {gql} from '@apollo/client';

/**
 * All documents target the admin endpoint (ADMIN-only). The filter output
 * selection uses the full envelope field set so a metadata-driven field always
 * round-trips on fetch; mutations return only scalars and we refetch after.
 */

const ERROR_FIELDS = `
  ... on Error {
    statusCode
    message
    errorTypeEnum
  }
`;

// The complete stored filter envelope, per the edit-fetch contract. Kept as one
// fragment so create/update/fetch cannot drift apart.
const THEME_FILTER_FIELDS = `
  filter {
    financialInstrument {
      assetClassKey
      instrumentKey
      explore
      noGroup
      countries
      industries
      maturityDate
      exchange
      group
      status
      id
      type
      listingType
      exclusive
      mostTraded
      highYield
      highReturn
      shariaCompliant
      groups
      riskLevel
      riskProfileId
      popular
      returnPeriod
      forDabaPro
      endsBefore
      ipoStatus
      ipoPhase
      marketPhase
      search
      limit
      page
      paginate
    }
    collection {
      orderType
      status
      collectionGroup
      industry
      page
      limit
      paginate
      all
      country
      exchanges
      search
      yeildSort
      returnPeriod
      sortBy
      sortDirection
      mostTradedWithinDays
      includeFacets
    }
  }
`;

export const GET_FILTER_STRUCTURE = gql`
  query InstrumentThemeFilterStructure($feature: InstrumentThemeFeature) {
    adminGetInstrumentThemeFilterStructure(feature: $feature) {
      __typename
      ... on ResponseWithInstrumentThemeFilterStructures {
        message
        data {
          feature
          filterField
          query
          argument
          inputType
          fields {
            name
            type
            required
            isList
            enumValues
            defaultValue
            description
          }
        }
      }
      ${ERROR_FIELDS}
    }
  }
`;

export const GET_THEMES = gql`
  query AdminInstrumentThemes($filters: InstrumentThemeListFilters) {
    adminGetInstrumentThemes(filters: $filters) {
      __typename
      ... on ResponseWithInstrumentThemes {
        message
        data {
          id
          icon
          name
          description
          features
          createdAt
          updatedAt
        }
        pagination {
          page
          limit
          pages
          total
          hasNextPage
          hasPrevPage
        }
      }
      ${ERROR_FIELDS}
    }
  }
`;

export const GET_THEME = gql`
  query AdminInstrumentTheme($id: ID!) {
    adminGetInstrumentTheme(id: $id) {
      __typename
      ... on ResponseWithInstrumentTheme {
        message
        data {
          id
          icon
          name
          description
          features
          createdAt
          updatedAt
          ${THEME_FILTER_FIELDS}
        }
      }
      ${ERROR_FIELDS}
    }
  }
`;

export const CREATE_THEME = gql`
  mutation CreateInstrumentTheme($input: CreateInstrumentThemeInput!) {
    createInstrumentTheme(input: $input) {
      __typename
      ... on ResponseWithInstrumentTheme {
        message
        data {
          id
          name
          features
        }
      }
      ${ERROR_FIELDS}
    }
  }
`;

export const UPDATE_THEME = gql`
  mutation UpdateInstrumentTheme($id: ID!, $input: UpdateInstrumentThemeInput!) {
    updateInstrumentTheme(id: $id, input: $input) {
      __typename
      ... on ResponseWithInstrumentTheme {
        message
        data {
          id
          name
          features
        }
      }
      ${ERROR_FIELDS}
    }
  }
`;

export const DELETE_THEME = gql`
  mutation DeleteInstrumentTheme($id: ID!) {
    deleteInstrumentTheme(id: $id) {
      __typename
      ... on ResponseWithInstrumentTheme {
        message
        data {
          id
          name
          features
        }
      }
      ${ERROR_FIELDS}
    }
  }
`;
